module.exports = __webpack_public_path__ + "media/application/images/svgs/icon-close-2c99ad32de68845d2e5012fa190c3964.svg";